import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getDestinations = (params) => api.get("/destinations", { params }).then((r) => r.data);
export const getDestination = (id) => api.get(`/destinations/${id}`).then((r) => r.data);
export const getCountries = () => api.get("/countries").then((r) => r.data);
export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getRates = () => api.get("/currency/rates").then((r) => r.data);
export const saveItinerary = (payload) => api.post("/itineraries", payload).then((r) => r.data);

export async function* streamChat({ session_id, message, language }) {
  const res = await fetch(`${API}/ai/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id, message, language }),
  });
  if (!res.ok || !res.body) throw new Error("chat failed");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      const payload = line.slice(5).trimStart();
      if (payload === "[DONE]") return;
      if (payload.startsWith("[error]")) throw new Error(payload);
      yield payload;
    }
  }
}
